module.exports = __webpack_public_path__ + "img/zoom-small-logo.f0937e2b.png";